<template>
  <div>
    <v-btn
      v-if="!dismissed"
      color="primary"
      elevation="6"
      class="button-style text-none"
      @click="panelOpen = true"
    >
      <v-icon
        left
        large
      >
        mdi-chevron-left
      </v-icon>
      <span class="py-8">
        For You
      </span>
    </v-btn>

    <v-dialog
      v-model="panelOpen"
      max-width="400"
    >
      <PartnerCardPreview
        :card="card"
        variant="default"
        interactive
        fluid
        closable
        style="max-height: 50vh; overflow-y: auto;"
        @cta-click="$emit('cta-click', $event)"
        @close="panelOpen = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import PartnerCardPreview from './PartnerCardPreview.vue';

export default {
  name: 'PartnerCardMobileFAB',

  components: { PartnerCardPreview },

  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      panelOpen: false,
      dismissed: false,
    };
  },

  watch: {
    panelOpen(val) {
      if (!val) this.dismissed = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.button-style {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 200;
  border-radius: 100px 0 0 100px !important;
}
</style>
